// =============================================================================
// PRIVILEGE CONSTANTS (Frontend)
// =============================================================================
// Aligned with backend: wfe-be/constants/privileges.js
// Following DDD principles and YAGNI - only export what's actually used

/**
 * Standard CRUD privilege actions for RBAC checking
 * Used for permission system and access control
 */
export const PRIVILEGE_ACTIONS = {
  CREATE: 'create',
  READ: 'read',
  EDIT: 'edit',
  DELETE: 'delete',
  EXPORT: 'export',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

/**
 * Request-specific privilege actions
 * Used for request management permission checking
 */
export const REQUEST_PRIVILEGES = {
  CREATE_COMMENT: 'create-comment',
  READ_COMMENT: 'read-comment',
  REVIEW: 'review', // Internal: admin requests access. External: read-only view of all forms on own requests
  COMMITTEE_REVIEW: 'committee-review', // External users only
};

// =============================================================================
// BACKWARDS COMPATIBILITY
// =============================================================================
// For compatibility with existing privilege.constant.js usage
export const PRIVILEGES = PRIVILEGE_ACTIONS;

export const EXTERNAL_MY_ORG_PRIVILEGES = {
  VIEW_MY_ORG: 'view-organization-structure',
  EDIT_MY_ORG: 'edit-organization',
  EDIT_MY_ORG_DEPARTMENTS: 'edit-department-details',
  ADD_MY_ORG_DEPARTMENTS: 'create-delete-departments',
  INVITE_MY_ORG_USERS: 'invite-users-by-email',
};
